import * as Sentry from '@sentry/react'
import { QueryClient, QueryCache } from '@tanstack/react-query'

export const queryClientOptions = {
  defaultOptions: {
    queries: {
      refetchOnWindowFocus: true,
      refetchOnMount: 'always' as const,
      staleTime: 0,
      retry: false,
    },
  },
  queryCache: new QueryCache({
    onError: err => {
      Sentry.captureException(err)
    },
  }),
}
export const queryClient = new QueryClient(queryClientOptions)
